<template>
  <div class="mb-2">
    <div class="d-flex align-center mb-1">
      <span class="caption font-weight-medium">{{ label }}</span>
      <v-spacer />
      <v-chip x-small :color="statusColor" dark label>{{ statusText }}</v-chip>
      <v-icon v-if="state === 'paused'" small class="ml-1">mdi-pause-circle</v-icon>
    </div>
    <v-progress-linear
      :value="percentage"
      :color="barColor"
      height="8"
      rounded
      background-color="grey lighten-3"
    />
    <div class="d-flex justify-space-between mt-1">
      <span class="caption grey--text">{{ formatTime(elapsedMinutes) }}</span>
      <span class="caption grey--text">Target: {{ formatTime(targetMinutes) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlaProgressBar',

  props: {
    label: {
      type: String,
      required: true,
    },
    elapsedMinutes: {
      type: Number,
      required: true,
    },
    targetMinutes: {
      type: Number,
      default: 0,
    },
    state: {
      type: String,
      required: true,
      validator: (value) => ['running', 'paused', 'met', 'breached', 'waiting', 'none'].includes(value),
    },
  },

  computed: {
    percentage() {
      if (this.targetMinutes === 0) return 100
      const raw = (this.elapsedMinutes / this.targetMinutes) * 100
      return Math.min(raw, 100)
    },

    barColor() {
      if (this.state === 'met') return 'success'
      if (this.state === 'breached') return 'error'
      if (this.state === 'waiting') return 'grey'

      const pct = (this.elapsedMinutes / this.targetMinutes) * 100
      if (pct < 50) return 'success'
      if (pct < 75) return 'lime darken-1'
      if (pct < 90) return 'orange'
      return 'error'
    },

    statusColor() {
      if (this.state === 'met') return 'success'
      if (this.state === 'breached') return 'error'
      if (this.state === 'paused') return 'orange'
      if (this.state === 'waiting') return 'grey'

      // 'running' - derive from percentage
      const pct = (this.elapsedMinutes / this.targetMinutes) * 100
      if (pct < 50) return 'success'
      if (pct < 75) return 'lime darken-1'
      if (pct < 90) return 'orange'
      return 'error'
    },

    statusText() {
      const map = {
        met: 'Rispettato',
        breached: 'Violato',
        paused: 'In pausa',
        waiting: 'In attesa',
        running: 'In corso',
      }
      return map[this.state] || this.state
    },
  },

  methods: {
    formatTime(minutes) {
      if (!minutes || minutes <= 0) return '0m'
      const h = Math.floor(minutes / 60)
      const m = minutes % 60
      if (h === 0) return `${m}m`
      if (m === 0) return `${h}h`
      return `${h}h ${m}m`
    },
  },
}
</script>
